// ===== PACKAGE DATA =====
const packages = [
  {
    name: "TPU Zenith",
    warranty: "Lifetime Warranty",
    price: "13,200",
    thickness: "LIFETIME WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_Zenith_PPF.webp",
    desc: "Elevate your vehicle's shine and shield with premium TPU Zenith Paint Protection Film.",
    stats: [
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",     lbl: "Self-Healing" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "LIFETIME", lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface",       lbl: "Gloss - 98" }
    ],
    techSpecs: [
  ["Base Film Type",                          "PCDL TPU"],
  ["Adhesive Type",                           "Ashland Glue"],
  ["Film Thickness",                          "190 Micron"],
  ["Film Specification",                      "1.52*15m"],
  ["Temperature Resistance",                  "-40°~120°C"],
  ["Peel Adhesion",                           "≥15 (N/25mm)"],
  ["Yellowing Resistance",                    "ΔE ≤ 2"],
  ["Anti Rock Chip Test",                     "Pass"],
  ["Anti-Stain",                              "Pass"],
  ["Elongation Rate at Break (TPU Film)",     "≥300%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥110%"]
],
    pricing: [
      ["FULL CAR",       "AED 13,200", "AED 15,000", "AED 16,800"],
      ["FULL FRONT KIT", "AED 5,400",  "AED 6,000",  "AED 6,600"],
      ["FRONT HOOD",     "AED 1,500",  "AED 1,800",  "AED 2,100"],
      ["FRONT & BUMPER",     "AED 3,000",  "AED 3,300",  "AED 3,600"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Zenith%20(Clear%20Gloss)).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Satin Infinity",
    warranty: "10 Year Warranty",
    price: "13,200",
    thickness: "10 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_Clear_Satin_infinity_PPF.webp",
    desc: "Premium matte TPU protection film with satin luxury finish.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",  lbl: "Self-Healing" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "10 YR", lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/REAL_MATTE_LOOK.png?v=1779258115", val: "Real Satin", lbl: "Look" }
    ],
    techSpecs: [
  ["Base Film Type",                             "Lubrizol Polycaprolactone TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "195 Micron"],
  ["Film Specification",                         "1.52*15m"],
  ["Temperature Resistance",                     "-40°~120°C"],
  ["Peel Adhesion",                              "≥15 (N/25mm)"],
  ["Yellowing Resistance",                       "ΔE ≤ 2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥250%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥90%"]
],
   pricing: [
      ["FULL CAR",       "AED 13,200", "AED 15,000", "AED 16,800"],
      ["FULL FRONT KIT", "AED 5,400",  "AED 6,000",  "AED 6,600"],
      ["FRONT HOOD",     "AED 1,500",  "AED 1,800",  "AED 2,100"],
      ["FRONT & BUMPER",     "AED 3,000",  "AED 3,300",  "AED 3,600"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Clear%20Satin%20Infinity%20(Clear%20matte)).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Phantom Gloss Black",
    warranty: "5 Year Warranty",
    price: "12,100",
    thickness: "5 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_phantom_Gloss_black_PPF.webp",
    desc: "Bold gloss black TPU film for a dramatic paint transformation with full protection.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",  lbl: "Self-Healing" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "5 YR",  lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface", lbl: "Gloss - 97" }
    ],
  techSpecs: [
  ["Base Film Type",                             "BASF Polycaprolactone Aliphatic TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "200 Micron"],
  ["Film Specification",                         "1.52*15m"],
  ["Temperature Resistance",                     "-40°~120°C"],
  ["Peel Adhesion",                              "≥15 (N/25mm)"],
  ["Yellowing Resistance",                       "ΔE ≤ 2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥250%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥160%"]
],
   pricing: [
      ["FULL CAR",       "AED 12,100", "AED 13,750", "AED 15,400"],
      ["FULL FRONT KIT", "AED 4,900",  "AED 5,500",  "AED 6,050"],
      ["FRONT HOOD",     "AED 1,375",  "AED 1,650",  "AED 1,925"],
      ["FRONT & BUMPER",     "AED 2,750",  "AED 3,025",  "AED 3,300"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Phantom%20Gloss%20Black).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Phantom Matte Black",
    warranty: "5 Year Warranty",
    price: "12,100",
    thickness: "5 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_phantom_matte_black_PPF.webp",
    desc: "Stealth matte black finish with BASF TPU for an aggressive, understated look.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",  lbl: "Self-Healing" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "5 YR",  lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/REAL_MATTE_LOOK.png?v=1779258115", val: "Black Matte", lbl: "Look" }
    ],
    techSpecs: [
  ["Base Film Type",                             "BASF Polycaprolactone Aliphatic TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "200 Micron"],
  ["Film Specification",                         "1.52*15m"],
  ["Temperature Resistance",                     "-40°~120°C"],
  ["Peel Adhesion",                              "≥15 (N/25mm)"],
  ["Yellowing Resistance",                       "ΔE ≤ 2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥250%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥90%"]
],
    pricing: [
      ["FULL CAR",       "AED 12,100", "AED 13,800", "AED 15,400"],
      ["FULL FRONT KIT", "AED 4,800",  "AED 5,500",  "AED 6,100"],
      ["FRONT HOOD",     "AED 1,350",  "AED 1,550",  "AED 1,800"],
       ["FRONT & BUMPER",     "AED 2,750",  "AED 3,025",  "AED 3,300"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Phantom%20Matte%20Black).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Supreme Shield",
    warranty: "7 Year Warranty",
    price: "11,000",
    thickness: "7 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_Supreme_Shield_PPF.webp",
    desc: "Supreme Shield TPU film with superior durability and high gloss finish.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%", lbl: "Self-Healing" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "7 YR", lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface",  lbl: "Gloss - 98" }
    ],
   techSpecs: [
  ["Base Film Type",                             "Lubrizol Polycaprolactone TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "216 Micron"],
  ["Film Specification",                         "1.52*15m"],
  ["Temperature Resistance",                     "-40°~120°C"],
  ["Peel Adhesion",                              "≥15 (N/25mm)"],
  ["Yellowing Resistance",                       "ΔE ≤ 2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥250%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥105%"]
],
    pricing: [
      ["FULL CAR",       "AED 11,000", "AED 12,500", "AED 14,000"],
      ["FULL FRONT KIT", "AED 4,500",  "AED 5,000",  "AED 5,500"],
      ["FRONT HOOD",     "AED 1,250",  "AED 1,500",  "AED 1,750"],
       ["FRONT & BUMPER",     "AED 2,500",  "AED 2,750",  "AED 3,000"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Supreme%20Shield%20(Clear%20Gloss)).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Clear Matte",
    warranty: "5 Year Warranty",
    price: "9,900",
    thickness: "5 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_Clear_Matte_PPF.webp",
    desc: "Elegant clear matte TPU protection that transforms any colour into a satin finish.",

    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",  lbl: "Heat Self-Heading" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "5 YR",  lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/REAL_MATTE_LOOK.png?v=1779258115", val: "Matte", lbl: "Finish" }
    ],
    techSpecs: [
  ["Base Film Type",                             "BASF Polycaprolactone Aliphatic TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "190 Micron"],
  ["Film Specification",                         "1.52*15m"],
  ["Temperature Resistance",                     "-40°~120°C"],
  ["Peel Adhesion",                              "≥15 (N/25mm)"],
  ["Yellowing Resistance",                       "ΔE ≤ 2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥250%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥90%"]
],
    pricing: [
      ["FULL CAR",       "AED 9,900",  "AED 11,250", "AED 12,600"],
      ["FULL FRONT KIT", "AED 4,050",  "AED 4,500",  "AED 4,950"],
      ["FRONT HOOD",     "AED 1,125",  "AED 1,350",  "AED 1,575"],
       ["FRONT & BUMPER",     "AED 2,250",  "AED 2,475",  "AED 2,700"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Clear%20Matte).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Phoenix",
    warranty: "5 Year Warranty",
    price: "9,900",
    thickness: "5 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_Phoenix_PPF.webp",
    desc: "Reliable Lubrizol-based clear gloss protection with exceptional value.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",  lbl: "Heat Self-Heading" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "5 YR",  lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface", lbl: "Gloss - 98" }
    ],
  techSpecs: [
  ["Base Film Type",                             "Lubrizol Polycaprolactone TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "190 Micron"],
  ["Film Specification",                         "1.52*15m"],
  ["Temperature Resistance",                     "-40°~120°C"],
  ["Peel Adhesion",                              "≥15 (N/25mm)"],
  ["Yellowing Resistance",                       "ΔE ≤ 2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥250%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥180%"]
],
     pricing: [
      ["FULL CAR",       "AED 9,900",  "AED 11,250", "AED 12,600"],
      ["FULL FRONT KIT", "AED 4,050",  "AED 4,500",  "AED 4,950"],
      ["FRONT HOOD",     "AED 1,125",  "AED 1,350",  "AED 1,575"],
       ["FRONT & BUMPER",     "AED 2,250",  "AED 2,475",  "AED 2,700"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Phoenix).%20Please%20share%20more%20details."
  },
  {
    name: "TPU ProShield",
    warranty: "5 Year Warranty",
    price: "9,900",
    thickness: "5 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_Proshield_PPF.webp",
    desc: "Professional-grade BASF clear gloss protection at an accessible price point.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",  lbl: "Heat Self-Heading" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "5 YR",  lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface", lbl: "Gloss - 97" }
    ],
   techSpecs: [
  ["Base Film Type",                             "BASF Polycaprolactone Aliphatic TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "190 Micron"],
  ["Film Specification",                         "1.52*15m | 1.82*15m"],
  ["Temperature Resistance",                     "-40°~120°C"],
  ["Peel Adhesion",                              "≥15 (N/25mm)"],
  ["Yellowing Resistance",                       "ΔE ≤ 2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥250%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥110%"]
],
  pricing: [
      ["FULL CAR",       "AED 9,900",  "AED 11,250", "AED 12,600"],
      ["FULL FRONT KIT", "AED 4,050",  "AED 4,500",  "AED 4,950"],
      ["FRONT HOOD",     "AED 1,125",  "AED 1,350",  "AED 1,575"],
       ["FRONT & BUMPER",     "AED 2,250",  "AED 2,475",  "AED 2,700"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20ProShield).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Prime",
    warranty: "3 Year Warranty",
    price: "8,800",
    thickness: "3 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_Prime_PPF.webp",
    desc: "Entry-level TPU protection for everyday drivers seeking reliable coverage.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",  lbl: "Heat Self-Heading" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "3 YR",  lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface", lbl: "Gloss - 97" }
    ],
  techSpecs: [
  ["Base Film Type",                             "Wanhua Polycaprolactone TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "190 Micron"],
  ["Film Specification",                         "1.52*15m"],
  ["Temperature Resistance",                     "-40°~120°"],
  ["Peel Adhesion",                              "≥15 (N/25mm)"],
  ["Yellowing Resistance",                       "ΔE ≤ 2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥250%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥110%"]
],
    pricing: [
      ["FULL CAR",       "AED 8,800",  "AED 10,000", "AED 11,200"],
      ["FULL FRONT KIT", "AED 3,600",  "AED 4,000",  "AED 4,400"],
      ["FRONT HOOD",     "AED 1,000",    "AED 1,200",  "AED 1,400"],
      ["FRONT & BUMPER",     "AED 2,000",  "AED 2,200",  "AED 2,400"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Prime).%20Please%20share%20more%20details."
  },
  {
    name: "TPU 4 Layer Color PPF",
    warranty: "8 YEAR WARRANTY",
    price: "15,400",
    thickness: "8 year warranty",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_4_Layer_Color_PPF.webp",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",     lbl: "Heat Self-Heading" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "8 YR",  lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface", lbl: "Gloss - 98" }
    ],
    techSpecs: [
  ["Base Film Type",                             "BASF Polycaprolactone Aliphatic TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "203 ± 12 Micron"],
  ["Film Specification",                         "1.52 × 16 m"],
  ["Temperature Resistance",                     "-40° ~ 80°C"],
  ["Peel Adhesion",                              "600 gf/in"],
  ["Yellowing Resistance",                       "≤2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥221%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥100%"]
],
    pricing: [
      ["FULL CAR",       "AED 15,400", "AED 17,500", "AED 19,600"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%204%20Layer%20Color%20PPF).%20Please%20share%20more%20details."
  },
  {
    name: "TPU 4 Layer Texture",
    warranty: "8 YEAR WARRANTY",
    price: "15,400",
    thickness: "8 year warranty",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_4_Layer_Texture_PPF.webp",
    desc: "Premium 4-layer textured PPF with Carbon Fiber finish for a motorsport-inspired look.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",    lbl: "Heat Self-Heading" },
      { icon: "award", img: "v", val: "8 YR", lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface",   lbl: "Gloss - 98" }
    ],
  techSpecs: [
  ["Base Film Type",                             "BASF Polycaprolactone Aliphatic TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "228±12 Micron"],
  ["Film Specification",                         "1.52*15m"],
  ["Temperature Resistance",                     "-40°~80°C"],
  ["Peel Adhesion",                              "800-1500 gf t"],
  ["Yellowing Resistance",                       "≤2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥411%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥200%"]
],
     pricing: [
      ["FULL CAR",       "AED 15,400", "AED 17,500", "AED 19,600"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%204%20Layer%20Texture%20%2F%20Carbon%20Fiber%20PPF).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Super Chrome PPF",
    warranty: "8 Year Warranty",
    price: "17,600",
    thickness: "8 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_4_Super_Chrome_PPF.webp",
    desc: "The most striking finish — a full mirror chrome transformation with long-lasting protection.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",   lbl: "Heat Self-Heading" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "8 YR",   lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface", lbl: "Gloss - 98" }
    ],
  techSpecs: [
  ["Base Film Type",                             "BASF Polycaprolactone Aliphatic TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "203 ± 12 Micron"],
  ["Film Specification",                         "1.52 × 16 m"],
  ["Temperature Resistance",                     "-40° ~ 80°C"],
  ["Peel Adhesion",                              "600 gf/in"],
  ["Yellowing Resistance",                       "≤2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥221%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥100%"]
],
    pricing: [
      ["FULL CAR",       "AED 17,600", "AED 20,000", "AED 22,400"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Chrome%20%2F%20Super%20Chrome%20PPF).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Printable PPF",
    warranty: "5 Year Warranty",
    price: "15,400",
    thickness: "5 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_Printable_White_and_Clear_PPF.webp",
    desc: "Printable TPU PPF available in White & Clear base — ideal for custom designs and wraps with full protection.",
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%", lbl: "Heat Self-Heading" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "5 YR",  lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface",     lbl: "Gloss - 98" }
    ],
    techSpecs: [
  ["Base Film Type",                             "BASF Polycaprolactone Aliphatic TPU"],
  ["Adhesive Type",                              "Ashland Glue"],

  // Film Thickness per variant
  ["Film Thickness (TPU Matte Base PPF)",        "216 Micron"],
  ["Film Thickness (TPU Glossy Base PPF)",       "216 Micron"],
  ["Film Thickness (TPU Clear Print PPF)",       "196 Micron"],
  ["Film Thickness (TPU Luminous Base PPF)",     "143 Micron"],
  ["Film Thickness (TPU White Base PPF)",        "125 Micron"],
  ["Film Thickness (TPU Chrome Base PPF)",       "296 Micron"],

  ["Film Specification",                         "1.52*20m"],
  ["Temperature Resistance",                     "-40°~80°C"],
  ["Peel Adhesion",                              "600 gf t"],
  ["Yellowing Resistance",                       "≤2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],

  // Elongation Rate at Break (TPU Film) per variant
  ["Elongation Rate at Break - Matte (TPU Film)",   "≥325%"],
  ["Elongation Rate at Break - Glossy (TPU Film)",  "≥298%"],
  ["Elongation Rate at Break - Clear (TPU Film)",   "≥365%"],
  ["Elongation Rate at Break - Luminous (TPU Film)","≥498%"],
  ["Elongation Rate at Break - White (TPU Film)",   "≥513%"],
  ["Elongation Rate at Break - Chrome (TPU Film)",  "≥451%"],

  // Elongation Rate at Break (Hard Coating/MD) per variant
  ["Elongation Rate at Break - Matte (Hard Coating/MD)",   "≥140%"],
  ["Elongation Rate at Break - Glossy (Hard Coating/MD)",  "≥90%"],
  ["Elongation Rate at Break - Clear (Hard Coating/MD)",   "≥180%"],
  ["Elongation Rate at Break - Luminous (Hard Coating/MD)","≥180–230%"],
  ["Elongation Rate at Break - White (Hard Coating/MD)",   "≥180–230%"],
  ["Elongation Rate at Break - Chrome (Hard Coating/MD)",  "≥160–210%"],

  ["Warranty (PPF)",                             "5 Year"],
  ["Warranty (Print & Ink)",                     "3 Year"]
],
    pricing: [
      ["FULL CAR",       "AED 15,400", "AED 17,500", "AED 19,600"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Printable%20PPF%20(%20White%20%26%20Clear%20Base)).%20Please%20share%20more%20details."
  },
  {
    name: "TPU Printable PPF Chrome & Luminous",
    warranty: "5 Year Warranty",
    price: "20,900",
    thickness: "5 YEAR WARRANTY",
    img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/DE_Website_PPF__TPU_Printable_Chrome_luminous_PPF.webp",
    desc: "Premium printable PPF in Chrome & Luminous base — the ultimate in custom visual impact with full paint protection.",
  
    stats: [
      { icon: "heal",  img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/100_HEAT_SELF-HEALING.png?v=1779258116", val: "100%",  lbl: "Heat Self-Heading" },
      { icon: "award", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/YEAR_WARRANTY.png?v=1779258116", val: "5 YR",   lbl: "Warranty" },
      { icon: "gloss", img: "https://cdn.shopify.com/s/files/1/0954/5469/1603/files/60_SURFACE_gloss.png?v=1779258116", val: "60° Surface", lbl: "Gloss - 98" }
    ],
   techSpecs: [
  ["Base Film Type",                             "BASF Polycaprolactone Aliphatic TPU"],
  ["Adhesive Type",                              "Ashland Glue"],
  ["Film Thickness",                             "143 Micron"],
  ["Film Specification",                         "1.52×20m"],
  ["Temperature Resistance",                     "-40°~80°C"],
  ["Peel Adhesion",                              "600 gf t"],
  ["Yellowing Resistance",                       "≤2"],
  ["Anti Rock Chip Test",                        "Pass"],
  ["Anti-Stain",                                 "Pass"],
  ["Elongation Rate at Break (TPU Film)",        "≥498%"],
  ["Elongation Rate at Break (Hard Coating/MD)", "≥180–230%"],
  ["Warranty (PPF)",                             "5 Year"],
  ["Warranty (Print & Ink)",                     "3 Year"]
],
    pricing: [
      ["FULL CAR",       "AED 20,900", "AED 23,750", "AED 26,600"]
    ],
    wa: "971509526680",
    waMsg: "Hello%2C%20I%20am%20interested%20in%20the%20PPF%20Package(TPU%20Printable%20PPF%20(Chrome%20%26%20Luminous)).%20Please%20share%20more%20details."
  }
];

// ===== SVG ICONS (card grid mein use hota hai) =====
function getIcon(type) {
  const c = '#e5035a';
  if (type === 'heal') {
    return `<svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22" cy="30" r="8" stroke="${c}" stroke-width="1.6"/>
      <path d="M16 8 Q10 14 10 22 Q10 28 14 32" stroke="${c}" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M28 8 Q34 14 34 22 Q34 28 30 32" stroke="${c}" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M19 8 h6 M22 5 v6" stroke="${c}" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M18 30 h8 M22 26 v8" stroke="${c}" stroke-width="2" stroke-linecap="round"/>
    </svg>`;
  }
  if (type === 'award') {
    return `<svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22" cy="18" r="11" stroke="${c}" stroke-width="1.6"/>
      <path d="M15 18 l5 5 9-9" stroke="${c}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17 29 l-3 8 8-4 8 4-3-8" stroke="${c}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  }
  return `<svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22" cy="22" r="12" stroke="${c}" stroke-width="1.6"/>
    <path d="M22 15 v7 l5 3" stroke="${c}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 22 h4 M30 22 h4 M22 10 v4 M22 30 v4" stroke="${c}" stroke-width="1.4" stroke-linecap="round"/>
  </svg>`;
}

// ===== RENDER CARDS =====
function renderCards() {
  const grid = document.getElementById('grid');
  grid.innerHTML = packages.map((p, i) => `
    <div class="card" onclick="openModal(${i})">
      <div class="img-wrap">
        <img class="card-img" src="${p.img}" alt="${p.name}"
          onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'">
        <div class="img-ph">
          <svg width="110" viewBox="0 0 200 80" fill="none">
            <ellipse cx="50" cy="62" rx="16" ry="12" fill="#fce8ef"/>
            <ellipse cx="150" cy="62" rx="16" ry="12" fill="#fce8ef"/>
            <path d="M20 55 Q30 30 70 25 L110 20 Q140 18 160 28 L185 45 L185 58 Q170 60 155 50 Q100 55 50 55 Q35 55 20 55Z"
              fill="#f0f0f5" stroke="#ddd" stroke-width="1"/>
          </svg>
        </div>
      
      </div>
      <div class="card-body">
        <p class="card-cat">Paint Protection Film</p>
        <h3 class="card-name">${p.name}</h3>
        <div class="specs">
          <div class="spec-row"><span class="spec-dot"></span><span class="spec-txt">${p.thickness}</span></div>
        </div>
        <div class="divider"></div>
        <p class="price-lbl">Starting From</p>
        <p class="price"><span class="price-aed">AED </span>${p.price}</p>
        <div class="actions">
          <a class="btn-details">Know More <i class="fa-solid fa-circle-arrow-right"></i></a>
          <a class="btn-enquiry"
            href="https://wa.me/${p.wa}?text=${p.waMsg}"
            target="_blank"
            onclick="event.stopPropagation()"><i class="fa-brands fa-whatsapp" style="margin-right:5px;"></i> Enquiry Now</a>
        </div>
      </div>
    </div>
  `).join('');
}

// ===== MODAL STAT ICON — ab img tag use karta hai =====
// Agar stats object mein img field hai → <img> tag show hoga
// Agar img nahi hai → fallback SVG show hoga
function getStatIcon(type, imgUrl) {
  // IMAGE TAG — yahi main change hai
  if (imgUrl && imgUrl !== 'YOUR_ICON_1_URL_HERE' && imgUrl !== 'YOUR_ICON_2_URL_HERE' && imgUrl !== 'YOUR_ICON_3_URL_HERE') {
    return `<img src="${imgUrl}" alt="${type}" style="width:48px;height:48px;object-fit:contain;display:block;">`;
  }

  // FALLBACK SVG (jab tak image URL nahi daala)
  const c = '#e5035a';
  if (type === 'heal' || type === 'refresh') {
    return `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="16" stroke="${c}" stroke-width="2"/>
      <path d="M24 16 v8 l5 3" stroke="${c}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14 24 h4 M30 24 h4 M24 14 v4 M24 30 v4" stroke="${c}" stroke-width="1.6" stroke-linecap="round"/>
    </svg>`;
  }
  if (type === 'award') {
    return `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="20" r="12" stroke="${c}" stroke-width="2"/>
      <path d="M18 20 l4 4 8-9" stroke="${c}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18 31 l-3 9 9-4 9 4-3-9" stroke="${c}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  }
  return `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="14" stroke="${c}" stroke-width="2"/>
    <path d="M16 18 Q24 10 32 18 Q36 24 32 30" stroke="${c}" stroke-width="1.8" stroke-linecap="round"/>
    <circle cx="24" cy="24" r="4" stroke="${c}" stroke-width="1.8"/>
  </svg>`;
}

// ===== OPEN MODAL =====
function openModal(i) {
  const p = packages[i];

  document.getElementById('minner').innerHTML = `
    <div class="modal-cols">

      <!-- LEFT: dark panel -->
      <div class="mleft">
        <img class="mleft-img" src="${p.img}" alt="${p.name}"
          onerror="this.style.background='#222'">

        <div class="mleft-info">
          <p class="m-cat">Paint Protection Film</p>
          <h2 class="m-name">${p.name}</h2>
          <p class="m-war">${p.warranty}</p>
          <p class="m-desc">${p.desc}</p>

          <!-- 3 stat icons — ab img pass ho raha hai -->
          <div class="m-stats">
            ${p.stats.map(s => `
              <div class="m-stat">
                <div class="m-stat-icon">${getStatIcon(s.icon, s.img)}</div>
                <div class="m-stat-val">${s.val}<br>${s.lbl}</div>
              </div>
            `).join('')}
          </div>
        </div>

        <!-- Book button pinned at bottom of left -->
        <a class="btn-book"
          href="https://wa.me/${p.wa}?text=${p.waMsg}"
          target="_blank">Book Your Service</a>
      </div>

      <!-- RIGHT: white panel -->
      <div class="mright">

        <p class="sec-title">Technical Specifications</p>
        <table class="tech-table">
          <thead>
            <tr><th>Category</th><th>Value</th></tr>
          </thead>
          <tbody>
            ${p.techSpecs.map(r => `
              <tr><td>${r[0]}</td><td>${r[1]}</td></tr>
            `).join('')}
          </tbody>
        </table>

        <p class="price-sec-title">Package Pricing</p>
        <table class="price-table">
          <thead>
            <tr>
              <th>Package</th>
              <th>HATCHBACK/<br> SEDAN</th>
              <th>SUV/MUV & <br> LUXURY</th>
              <th>High End LUXURY <br> & TRUCK</th>
            </tr>
          </thead>
          <tbody>
            ${p.pricing.map(r => `
              <tr>${r.map(c => `<td>${c}</td>`).join('')}</tr>
            `).join('')}
          </tbody>
        </table>

      </div>

    </div>
  `;

  document.getElementById('mbg').classList.add('open');
  document.getElementById('mbg').scrollTop = 0;
}

// ===== CLOSE MODAL =====
function closeModal() {
  document.getElementById('mbg').classList.remove('open');
}

// ===== EVENTS =====
document.getElementById('modalClose').addEventListener('click', closeModal);
document.getElementById('mbg').addEventListener('click', function (e) {
  if (e.target === this) closeModal();
});
renderCards();